import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "@App/locales";

i18n
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    fallbackLng: "de_DE_formal",
    debug: false,

    // // have a common namespace used around the full app
    // ns: ["hero", "welcomeModal", "translation"],
    // defaultNS: "translation",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
